(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/api-errors.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/api-errors.js');

'use strict';

const logger = svs.tur.pay_lyckoplatsen.logger;
function showErrorDialog(title, message) {
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'exclamation-sign',
    title,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: svs.ui.dialog.message.align.CENTER,
      text: message
    }],
    actions: [{
      title: 'Jag förstår',
      callback: (e, forms, dialog) => {
        dialog.close();
      }
    }]
  }));
}
function apiErrors(error) {
  let errorTitle = 'Fel!';
  let errorMessage = 'Ett oväntat fel har inträffat.';
  const errorCode = parseInt(String(error.code).replace(/\s/g, ''), 10);
  switch (errorCode) {
    case 8103:
      errorTitle = 'Hoppsan!';
      errorMessage = 'Den platsen låg inte inom Sveriges gränser, gör ett nytt försök.';
      logger.error("User pin was outside Sweden.", error);
      break;
    case 8239:
      errorTitle = 'Hoppsan!';
      errorMessage = 'Du kan spela på max 10 lyckoplatser samma dragning.';
      logger.error("User played max amount of games per draw (10)", error);
      break;
    case 24131:
      errorTitle = 'Hoppsan!';
      errorMessage = 'Du kan prenumerera på max 10 lyckoplatser samma dragning.';
      logger.error("User is subcribing to max amount of games per draw (10)", error);
      break;
    default:
      svs.tur.apierrors.showErrorMessage({
        response: {
          error
        }
      });
      return;
  }
  showErrorDialog(errorTitle, errorMessage);
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  apiErrors
});

 })(window);